<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md7 lg7 xl5>
      <v-card class="elevation-5 pa-5 mb-5">
        <v-layout justify-center>
          <v-flex xs10 sm8 md7>
            <v-card-title
              class="font-weight-regular primary--text justify-center"
            >{{ $t("passwordChange.title") }}</v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-text-field
                  v-if="!passwordChangeRequired"
                  type="password"
                  :label="$t('passwordChange.password')"
                  v-model="password"
                  required
                  :rules="[rules.required]"
                  @input="() => (this.failed = false)"
                ></v-text-field>
                <v-text-field
                  type="password"
                  :label="$t('passwordChange.newPassword')"
                  v-model="newPassword"
                  required
                  :rules="[rules.required, rules.validPassword]"
                  validate-on-blur
                ></v-text-field>
                <v-text-field
                  type="password"
                  :label="$t('passwordChange.confirmNewPassword')"
                  required
                  :rules="[rules.required, rules.matches]"
                  validate-on-blur
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn
                block
                large
                class="primary white--text"
                @click="submit"
              >{{ $t("passwordChange.change") }}</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";

import ChangePasswordMutation from "../graphql/ChangePassword.gql";

export default {
  data() {
    return {
      valid: true,
      failed: false,
      password: "",
      newPassword: "",
      rules: {
        required: (value) => !!value || this.$i18n.t("validation.required"),
        validPassword: (value) => {
          const pattern = new RegExp(
            "^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,}))"
          );

          return (
            pattern.test(value) || this.$i18n.t("validation.invalidPassword")
          );
        },
        matches: (value) =>
          value === this.newPassword ||
          this.$i18n.t("validation.passwordMatch"),
      },
    };
  },
  computed: {
    ...mapState(["me", "passwordChangeRequired"]),
    oldPassword: function () {
      return this.passwordChangeRequired
        ? this.me.id.toString()
        : this.password;
    },
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$apollo
          .mutate({
            mutation: ChangePasswordMutation,
            variables: {
              password: this.oldPassword,
              newPassword: this.newPassword,
            },
          })
          .then(() => {
            this.$store.commit("change_password_success");
            this.$router.push("/");
            this.$store.commit("push_global_message", {
              color: "success",
              text: this.$i18n.t("passwordChange.success"),
            });
          })
          .catch(() => {
            this.failed = true;
            this.$refs.form.validate();
          });
      }
    },
  },
};
</script>
